import React, { useContext } from 'react';
import { observer } from 'mobx-react-lite';
import { Box, BoxProps, Typography } from '@mui/material';
import { UiContext } from 'shared/lib/contexts/uiContext';
import LimitedTypography from 'shared/lib/components/text/limitedTypography';
import { nbsp } from 'shared/lib/utils/uiConstants';
import { useBooleanScreens } from 'shared/hooks/useBooleanScreens';

export default observer(function BlockHeader({
  text,
  secondText,
  buttonsNode,
  size = 'large',
  forceBreak,
  ...other
}: {
  text: string;
  secondText?: string;
  buttonsNode?: React.ReactNode;
  size?: 'medium' | 'large';
  forceBreak?: boolean;
} & BoxProps) {
  const {
    spacings: { sp },
  } = useContext(UiContext);

  const { isLessLaptop } = useBooleanScreens();

  const variant = size === 'large' ? 'f36b' : 'f24b';

  return (
    <Box
      {...other}
      sx={{
        display: 'grid',
        gridTemplateColumns: isLessLaptop ? '1fr' : '620fr 540fr',
        width: 1,
        gap: sp.s100,
        ...other.sx,
      }}
    >
      <LimitedTypography
        clamp={3}
        variant={variant}
        sx={{ ...(!forceBreak ? { wordBreak: 'normal' } : {}) }}
      >
        {text}
        {secondText && (
          <Typography color="text.secondary" variant={variant}>
            {`${nbsp}${secondText}`}
          </Typography>
        )}
      </LimitedTypography>

      {buttonsNode && (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'end',
            height: 'min-content',
          }}
        >
          {buttonsNode}
        </Box>
      )}
    </Box>
  );
});
